import { render } from "./HeroiconsOutlineBadgeCheck.vue?vue&type=template&id=679f87a2"
const script = {}

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineBadgeCheck.vue"]])

export default __exports__